'use strict';

module.exports = require('./lib/methods')(require('./plain'));
